import { Fragment } from 'react';
import { Router, Switch, Route } from "react-router-dom";


import { createBrowserHistory } from "history";

//import { useDispatch } from 'react-redux';
import Chatbot from './components/Chatbot';




import { useEffect, useState } from "react";

import Login from "./pages/Login";
import Recovery from "./pages/Recovery";
import Dashboards from "./pages/Dashboards";
import Risk from "./pages/Risk";
import Gantt from "./pages/Gantt";
import Departments from "./pages/Departments";
import Incidents from "./pages/Incidents";
import Profile from "./pages/Profile";
import Settings from "./pages/Settings";
import Help from "./pages/Help";
import Users from "./pages/Users";
import Units from "./pages/Units";
import AIPage from "./pages/AI";
import Files from "./pages/Files";
import RiskLevels from "./pages/RiskLevels";
import Compliance from "./pages/Compliance";
import ComplianceCards from './pages/ComplianceCards';
import BowtieAnalysis from './pages/BowtieAnalysis';
import IT from "./pages/IT";
import WorkflowEditor from "./components/Workflow/WorkflowEditor";
import AllControls from "./pages/AllControls"



const history = createBrowserHistory();

function useNormalizeTo100({ targetDPR = 1, userScale = 1 } = {}) {
  useEffect(() => {
    const apply = () => {
      const dpr = window.devicePixelRatio || 1;
      const uiScale = (targetDPR / dpr) * userScale;
      document.documentElement.style.setProperty("--ui-scale", String(uiScale));
    };
    apply();

    const onResize = () => apply();
    window.addEventListener("resize", onResize);
    document.addEventListener("visibilitychange", apply);

    return () => {
      window.removeEventListener("resize", onResize);
      document.removeEventListener("visibilitychange", apply);
    };
  }, [targetDPR, userScale]);
}

function Main() {
  const [userScale, setUserScale] = useState(() => {
    const v = localStorage.getItem("uiScale");
    return v ? Number(v) : 1;
  });
  useEffect(() => { localStorage.setItem("uiScale", String(userScale)); }, [userScale]);

  // normalize UI to “true 100%”
  useNormalizeTo100({ targetDPR: 1, userScale });

  return (
    <div className="App">
      <Fragment>
        <Switch>
          <Route exact path="/" component={Login} />
          <Route exact path="/login" component={Login} />
          <Route exact path="/recovery" component={Recovery} />
          <Route exact path="/dashboards/:id?" component={Dashboards} />
          <Route exaxt path="/bowtie/:id" component={BowtieAnalysis}/>
          <Route exact path="/risk/:view_risk?" component={Risk} />
          <Route exact path="/actions" component={Gantt} />
          <Route exact path="/departments" component={Departments} />
          <Route exact path="/incidents/:risk_id" component={Incidents} />
          <Route exact path="/profile" component={Profile} />
          <Route exact path="/settings" component={Settings} />
          <Route exact path="/help" component={Help} />
          <Route exact path="/admin" component={Users} />
          <Route exact path="/units" component={Units} />
          <Route exact path="/controls" component={AllControls} />
          <Route exact path="/files" component={Files} />
          <Route exact path="/risk_levels" component={RiskLevels} />
          <Route exact path="/compliance" component={Compliance} />
          <Route exact path="/standards" component={ComplianceCards}/>
          <Route exact path="/IT" component={IT}/>
          <Route exact path="/edit/:id" component={WorkflowEditor} />
        </Switch>

        {/* optional: small zoom slider, can remove if boss says no */}
        {/* <div className="fixed bottom-4 right-4 bg-white/90 border rounded-lg shadow p-2 flex items-center gap-2 z-[9999]">
          <span className="text-xs text-gray-600">UI Zoom</span>
          <input type="range" min={0.9} max={1.2} step={0.05}
                 value={userScale}
                 onChange={(e) => setUserScale(Number(e.target.value))} />
        </div> */}
      </Fragment>
    </div>
  );
}

function App() {
  return (
    <Router history={history}>
      <Main />
      <Chatbot />
    </Router>
  );
}

export default App;
